/* Nova theme — core JS (no dependencies) */
(() => {
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- helpers ---------- */
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-on'), 3200);
  };
  T.toast = toast;

  /* ---------- reveal on scroll ---------- */
  const initReveal = (root = document) => {
    const els = $$('.reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(e => io.observe(e));
  };

  /* ---------- generic drawer (menu, cart) ---------- */
  let lastFocus = null;
  T.openDrawer = (wrap) => {
    if (!wrap) return;
    lastFocus = document.activeElement;
    wrap.classList.add('is-open');
    document.body.classList.add('no-scroll');
    const f = wrap.querySelector('.drawer [data-autofocus], .drawer button, .drawer a');
    setTimeout(() => f && f.focus(), 60);
  };
  T.closeDrawer = (wrap) => {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    if (!$('.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const wrap = document.getElementById(opener.dataset.open);
      if (wrap) { e.preventDefault(); T.openDrawer(wrap); }
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); T.closeDrawer(closer.closest('.is-open')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { const o = $$('.is-open').pop(); if (o) T.closeDrawer(o); }
  });

  /* ---------- cart ---------- */
  const SECTION = 'cart-drawer';
  const setCount = (n) => $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; });

  const renderDrawer = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawerInner');
    const cur = document.getElementById('CartDrawerInner');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      setCount(parseInt(fresh.dataset.count || '0', 10));
    }
  };

  T.cart = {
    async add(formData) {
      formData.append('sections', SECTION);
      formData.append('sections_url', window.location.pathname);
      const res = await fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      renderDrawer(data.sections && data.sections[SECTION]);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return data;
    },
    async change(line, quantity) {
      const res = await fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [SECTION], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      renderDrawer(data.sections && data.sections[SECTION]);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return data;
    },
    open() {
      const d = document.getElementById('CartDrawer');
      if (d && !document.body.classList.contains('template-cart')) T.openDrawer(d); else window.location.href = T.routes.cart;
    }
  };

  /* any form with [data-ajax-cart] adds via AJAX (falls back to normal submit) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || T.cartType === 'page' || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]') || (form.id && document.querySelector(`[form="${form.id}"][type=submit]`));
    const errBox = form.querySelector('[data-form-error]');
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    btn && btn.classList.add('is-loading');
    try {
      await T.cart.add(new FormData(form));
      T.cart.open();
    } catch (err) {
      if (errBox) { errBox.textContent = err.message; errBox.hidden = false; } else toast(err.message);
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  });

  /* drawer + cart page quantity controls */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    const line = parseInt(b.dataset.line, 10);
    const qty = parseInt(b.dataset.lineChange, 10);
    const row = b.closest('[data-line-row]');
    row && row.classList.add('is-busy');
    try {
      await T.cart.change(line, Math.max(0, qty));
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) { toast(err.message); row && row.classList.remove('is-busy'); }
  });

  /* ---------- qty input ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.closest('.qty').querySelector('input');
    const min = parseInt(input.min || '1', 10);
    const v = (parseInt(input.value, 10) || min) + (b.dataset.qty === '+' ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- announcement rotator ---------- */
  if (!customElements.get('announce-bar')) {
    customElements.define('announce-bar', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.i = 0;
        this.t = setInterval(() => {
          this.items[this.i].classList.remove('is-active');
          this.i = (this.i + 1) % this.items.length;
          this.items[this.i].classList.add('is-active');
        }, parseInt(this.dataset.speed || '4', 10) * 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
    });
  }

  /* ---------- slider arrows / dots ---------- */
  if (!customElements.get('slider-ui')) {
    customElements.define('slider-ui', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.querySelectorAll('[data-dir]').forEach(b => b.addEventListener('click', () => {
          const slide = this.track.firstElementChild;
          const w = slide ? slide.getBoundingClientRect().width + 16 : this.track.clientWidth;
          this.track.scrollBy({ left: w * (b.dataset.dir === 'next' ? 1 : -1), behavior: 'smooth' });
        }));
      }
    });
  }

  /* ---------- money ---------- */
  const formatMoney = (cents, format) => {
    format = format || T.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    const fmt = (n, dec, th = ',', ds = '.') => {
      const [i, d] = (n / 100).toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'");
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  };
  T.formatMoney = formatMoney;
  const priceHTML = (final, compare, badge) => {
    const sale = compare > final;
    let h = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(final)}</span>`;
    if (sale) {
      h += `<s class="price__compare">${formatMoney(compare)}</s>`;
      if (badge) h += `<span class="badge badge--sale">Save ${Math.round((compare - final) * 100 / compare)}%</span>`;
    }
    return h + '</div>';
  };

  /* ---------- dialogs ---------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-dialog-open]');
    if (o) { const d = document.getElementById(o.dataset.dialogOpen); if (d && d.showModal) { d.showModal(); document.body.classList.add('no-scroll'); } return; }
    const c = e.target.closest('[data-dialog-close]');
    if (c) { const d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('modal')) e.target.close();
  });
  document.addEventListener('close', (e) => { if (e.target.tagName === 'DIALOG') document.body.classList.remove('no-scroll'); }, true);

  /* ---------- delivery dates (business days, shopper's timezone) ---------- */
  const addBiz = (n) => { const d = new Date(); let a = 0; while (a < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; };
  const fmtDate = (d) => d.toLocaleDateString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
  const initDates = (root = document) => {
    $$('[data-dl-date]', root).forEach(el => { const n = parseInt(el.dataset.dlDate, 10); if (n > 0) el.textContent = fmtDate(addBiz(n)); });
    $$('[data-dl-range]', root).forEach(el => { const [a, b] = el.dataset.dlRange.split('-').map(Number); el.textContent = `${fmtDate(addBiz(a))} – ${fmtDate(addBiz(b))}`; });
  };

  /* ---------- product page ---------- */
  if (!customElements.get('product-info')) {
    customElements.define('product-info', class extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.form = this.querySelector('form[data-product-form]');
        this.idInput = this.form && this.form.querySelector('input[name=id]');
        this.qtyInput = this.querySelector('input[data-qty-hidden]');
        this.qtyVisible = this.querySelector('input[data-qty-visible]');
        this.url = this.dataset.url;
        this.isPdp = this.dataset.template === 'product';
        this.current = this.variants.find(v => this.idInput && String(v.id) === this.idInput.value) || this.variants[0];

        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-option], [data-option-select]')) this.onOptionChange();
          if (e.target.matches('[data-break]')) this.onBreak(e.target);
          if (e.target.matches('[data-qty-visible]') && this.qtyInput) this.qtyInput.value = Math.max(1, parseInt(e.target.value, 10) || 1);
        });
        this.initGallery();
        this.initSticky();
        this.markAvailability();
        initDates(this);
        if (this.current && this.current.featured_media && this.track && /[?&]variant=/.test(location.search)) {
          const sl = this.track.querySelector(`[data-media-id="${this.current.featured_media.id}"]`);
          if (sl && sl !== this.track.firstElementChild) this.track.scrollLeft = sl.offsetLeft - this.track.offsetLeft;
        }
        const checked = this.querySelector('[data-break]:checked');
        if (checked) this.onBreak(checked);
      }

      selected() {
        return $$('[data-option-group]', this).map(g => {
          const s = g.querySelector('[data-option-select]');
          if (s) return s.value;
          const c = g.querySelector('[data-option]:checked');
          return c ? c.value : null;
        });
      }

      markAvailability() {
        const sel = this.selected();
        $$('[data-option-group]', this).forEach((g, idx) => {
          g.querySelectorAll('[data-option]').forEach(inp => {
            const ok = this.variants.some(v => v.available && v.options[idx] === inp.value && v.options.every((o, j) => j === idx || sel[j] == null || o === sel[j]));
            inp.closest('.pill').classList.toggle('is-unavailable', !ok);
          });
          const label = g.querySelector('[data-selected-value]');
          if (label) label.textContent = sel[idx] || '';
        });
      }

      onOptionChange() {
        const sel = this.selected();
        const v = this.variants.find(x => x.options.every((o, i) => o === sel[i]));
        this.markAvailability();
        const btns = $$('[data-add-btn], [data-sticky-btn]', this);
        if (!v) {
          btns.forEach(b => { b.disabled = true; const l = b.querySelector('[data-label]'); if (l) l.textContent = T.strings.unavailable; });
          return;
        }
        this.current = v;
        if (this.idInput) this.idInput.value = v.id;
        $$('form[id^="Installments-"] input[name=id]', this).forEach(i => { i.value = v.id; i.dispatchEvent(new Event('change', { bubbles: true })); });
        btns.forEach(b => { b.disabled = !v.available; const l = b.querySelector('[data-label]'); if (l) l.textContent = v.available ? (b.dataset.addLabel || T.strings.addToCart) : T.strings.soldOut; });
        if (v.featured_media) this.goToMedia(v.featured_media.id);
        if (this.isPdp) { try { window.history.replaceState({}, '', `${this.url}?variant=${v.id}`); } catch (e) { /* noop */ } }
        this.renderPrices();
        if (this.isPdp) this.swapStock(v.id);
      }

      renderPrices() {
        const v = this.current; if (!v) return;
        const cmp = Math.max(v.compare_at_price || 0, v.price);
        const main = this.querySelector('[data-price-main]');
        if (main) main.innerHTML = priceHTML(v.price, cmp, true);
        const st = this.querySelector('[data-price-sticky]');
        if (st) st.innerHTML = priceHTML(v.price, cmp, false);
        $$('[data-break-price]', this).forEach(el => {
          const q = parseInt(el.dataset.qty, 10) || 1, d = parseInt(el.dataset.disc, 10) || 0;
          const base = v.price * q;
          el.innerHTML = priceHTML(Math.floor(base * (100 - d) / 100), Math.max(cmp * q, base), false);
        });
        this.updateBtnPrice();
      }

      updateBtnPrice() {
        const el = this.querySelector('[data-btn-price]'); if (!el || !this.current) return;
        const r = this.querySelector('[data-break]:checked');
        const q = this.qtyInput ? (parseInt(this.qtyInput.value, 10) || 1) : 1;
        const d = r ? (parseInt(r.dataset.disc, 10) || 0) : 0;
        el.textContent = formatMoney(Math.floor(this.current.price * q * (100 - d) / 100));
      }

      async swapStock(id) {
        const el = this.querySelector('[data-swap="stock"]'); if (!el) return;
        try {
          const html = await (await fetch(`${this.url}?variant=${id}&section_id=${this.dataset.section}`)).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-swap="stock"]');
          if (fresh) el.innerHTML = fresh.innerHTML;
        } catch (e) { /* keep */ }
      }

      onBreak(input) {
        const q = input.dataset.qtyValue || input.value;
        if (this.qtyInput) this.qtyInput.value = q;
        if (this.qtyVisible) this.qtyVisible.value = q;
        $$('.break', this).forEach(b => b.classList.toggle('is-selected', b.contains(input)));
        this.updateBtnPrice();
      }

      initGallery() {
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;
        const slides = $$('[data-media-id]', this.track);
        const thumbs = $$('[data-thumb]', this);
        const dots = $$('[data-dot]', this);
        const stage = this.querySelector('.pdp__stage');
        const setH = () => { if (stage) this.style.setProperty('--stage-h', stage.offsetHeight + 'px'); };
        let rt; setH(); window.addEventListener('resize', () => { setH(); clearTimeout(rt); rt = setTimeout(() => { const s = slides[this.activeIndex || 0]; if (s) this.track.scrollLeft = s.offsetLeft - this.track.offsetLeft; }, 120); }, { passive: true });
        const first = slides[0] && slides[0].querySelector('img');
        if (first && !first.complete) first.addEventListener('load', setH, { once: true });

        thumbs.forEach(t => t.addEventListener('click', () => this.goToMedia(t.dataset.thumb)));
        $$('[data-gallery-dir]', this).forEach(b => b.addEventListener('click', () => {
          const i = this.activeIndex || 0;
          const n = b.dataset.galleryDir === 'next' ? (i + 1) % slides.length : (i - 1 + slides.length) % slides.length;
          this.goToMedia(slides[n].dataset.mediaId);
        }));
        const setActive = (idx) => {
          this.activeIndex = idx;
          const id = slides[idx] && slides[idx].dataset.mediaId;
          thumbs.forEach(t => t.setAttribute('aria-current', t.dataset.thumb === id ? 'true' : 'false'));
          dots.forEach(d => d.classList.toggle('is-active', d.dataset.dot === id));
          const a = thumbs.find(t => t.dataset.thumb === id);
          const box = a && a.parentElement;
          if (box) {
            const vertical = box.scrollHeight > box.clientHeight + 4;
            if (vertical) box.scrollTo({ top: a.offsetTop - box.clientHeight / 2 + a.clientHeight / 2, behavior: 'smooth' });
            else box.scrollTo({ left: a.offsetLeft - box.clientWidth / 2 + a.clientWidth / 2, behavior: 'smooth' });
          }
          slides.forEach((s, j) => { if (j !== idx) s.querySelectorAll('video').forEach(v => v.pause()); });
        };
        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => setActive(Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
        }, { passive: true });

        const lb = this.querySelector('.lightbox');
        this.addEventListener('click', (e) => {
          const z = e.target.closest('[data-zoom], .pdp__img');
          if (!z || !lb || !lb.showModal) return;
          const slide = z.closest('[data-media-id]');
          const imgIdx = slides.filter(s => s.querySelector('.pdp__img')).indexOf(slide);
          lb.showModal(); document.body.classList.add('no-scroll');
          const target = lb.querySelectorAll('img')[Math.max(0, imgIdx)];
          if (target) setTimeout(() => target.scrollIntoView({ block: 'start' }), 30);
        });
      }

      goToMedia(id) {
        const slide = this.track && this.track.querySelector(`[data-media-id="${id}"]`);
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      initSticky() {
        const bar = this.querySelector('[data-sticky-bar]');
        const main = this.querySelector('[data-add-btn]');
        if (!bar || !main || !('IntersectionObserver' in window)) return;
        new IntersectionObserver(([en]) => {
          bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        }).observe(main);
        bar.querySelector('[data-sticky-btn]').addEventListener('click', () => {
          if (this.form.requestSubmit) this.form.requestSubmit(); else main.click();
        });
      }
    });
  }

  /* ---------- show more (long description) ---------- */
  if (!customElements.get('show-more')) {
    customElements.define('show-more', class extends HTMLElement {
      connectedCallback() {
        const body = this.querySelector('[data-more-body]');
        const btn = this.querySelector('[data-more-btn]');
        if (!body || !btn) return;
        const check = () => { if (body.scrollHeight <= body.clientHeight + 40 && !this.classList.contains('is-open')) { this.classList.add('is-short'); } };
        setTimeout(check, 300);
        btn.addEventListener('click', () => {
          const open = this.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open);
          btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
          if (!open) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  }

  /* ---------- before / after ---------- */
  if (!customElements.get('before-after')) {
    customElements.define('before-after', class extends HTMLElement {
      connectedCallback() {
        const r = this.querySelector('input[type=range]');
        if (!r) return;
        const set = () => this.style.setProperty('--pos', r.value + '%');
        r.addEventListener('input', set); set();
      }
    });
  }

  /* ---------- predictive search ---------- */
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type=search]');
        this.results = this.querySelector('[data-ps-results]');
        if (!this.input || !this.results) return;
        let t;
        this.input.addEventListener('input', () => {
          clearTimeout(t);
          const q = this.input.value.trim();
          if (q.length < 2) { this.results.innerHTML = ''; return; }
          t = setTimeout(async () => {
            try {
              const r = await fetch(`${T.routes.root}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`);
              const html = await r.text();
              const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ps-inner]');
              this.results.innerHTML = fresh ? fresh.innerHTML : '';
            } catch (e) { /* ignore */ }
          }, 220);
        });
      }
    });
  }

  /* ---------- product recommendations ---------- */
  if (!customElements.get('product-recs')) {
    customElements.define('product-recs', class extends HTMLElement {
      connectedCallback() {
        const load = () => fetch(this.dataset.url).then(r => r.text()).then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('product-recs');
          if (fresh && fresh.innerHTML.trim().length) { this.innerHTML = fresh.innerHTML; initReveal(this); }
          else { const s = this.closest('.shopify-section'); if (s) s.hidden = true; }
        }).catch(() => {});
        if (!('IntersectionObserver' in window)) return load();
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      }
    });
  }

  /* ---------- countdown (to a real date set by merchant) ---------- */
  if (!customElements.get('count-down')) {
    customElements.define('count-down', class extends HTMLElement {
      connectedCallback() {
        const end = new Date(this.dataset.end).getTime();
        if (isNaN(end)) return;
        const tick = () => {
          const d = end - Date.now();
          if (d <= 0) { this.closest('[data-countdown-wrap]')?.setAttribute('hidden', ''); clearInterval(this.t); return; }
          const p = n => String(n).padStart(2, '0');
          const days = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
          this.textContent = `${days ? days + 'd ' : ''}${p(h)}:${p(m)}:${p(s)}`;
        };
        tick(); this.t = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
    });
  }

  /* ---------- header scroll state ---------- */
  const header = () => $('.site-header');
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const h = header(); if (!h) return;
    const y = window.scrollY;
    h.classList.toggle('is-scrolled', y > 10);
    lastY = y;
  }, { passive: true });

  /* ---------- init + theme editor ---------- */
  const init = () => initReveal();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) T.openDrawer(document.getElementById('CartDrawer'));
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('#CartDrawer')) T.closeDrawer(document.getElementById('CartDrawer'));
  });
})();
